































































































































































import {Component, Inject, Provide, Vue} from 'vue-property-decorator';

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueDatePicker from "vuejs-datepicker";
import {paths} from "./path";
import {Permissions} from "./types";
import {logout, performLogin} from "@/endpoints";

library.add(faCircle);

Vue.use(BootstrapVue);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('datepicker', VueDatePicker);

@Component
export default class App extends Vue {

  @Inject("hasPermission")
  hasPermission: Function;

  Paths = paths;

  initialLoad: boolean = false;
  loaderClosing: boolean = false;

  isLinkApplicable = {
    vehicleLogs: false,
    dealershipManager: false,
    map: false,
    operations: false,
    users: false,
    application: false
  };

  randomPhrases = [
          "Prepping inspection cache...",
          "Creating dealership matrix...",
          "Initializing vehicle database...",
          "Analyzing printer connection..."
  ];

  async mounted() {

    // Check to see if the user object has changed within the store.
    // Once information has been acquired, the loader can be "dismissed"
    this.$store.watch(async (state) => {

      if(state.authenticatedContext) {

        this.isLinkApplicable = {
          vehicleLogs:
                  await this.hasPermission(Permissions.VIEW_VEHICLE_HISTORY_LOGS),
          dealershipManager:
                  await this.hasPermission(Permissions.ADD_EDIT_DEALERSHIPS),
          map:
                  await this.hasPermission(Permissions.VIEW_MAP),
          users:
                  await this.hasPermission(Permissions.ADD_EDIT_USERS),
          application:
                  await this.hasPermission(Permissions.APPLICATION_ACCESS),
          operations:
                  await this.hasPermission(Permissions.VIEW_OPERATION_WORKSHEET)
                  || await this.hasPermission(Permissions.VIEW_OPERATION_STOREVISIT)
                  || await this.hasPermission(Permissions.VIEW_OPERATION_REVENUE)
        };

        window.setTimeout(() => {
          this.loaderClosing = true;

          window.setTimeout(() => {
            this.initialLoad = true;
          }, 700);
        }, 500);

      }

    }, function (oldVal, newVal) {
      //
    }, {
      deep: true
    });
  }

  async onLogoutButtonClick() {

    try {
      const result = await logout();

      this.$store.commit('setUser', result);

      this.$router.push("/logout");
    } catch (e) {
      console.error(e);
    }
  }

  get getRandomPhrase() {
    return this.randomPhrases[Math.floor(Math.random() * this.randomPhrases.length)];
  }

}
